import { ref } from 'vue';
import { defineStore } from 'pinia';

export const usePaymentStore = defineStore('booking-wizard/payment', () => {
    // State
    const bookingHasAlreadyBeenPaid = ref<boolean>(false);
    const pinPaymentFailed = ref<boolean>(false);

    // Getters

    // Actions
    const reset = () => {
        bookingHasAlreadyBeenPaid.value = false;
        pinPaymentFailed.value = false;
    };

    return {
        // State
        bookingHasAlreadyBeenPaid,
        pinPaymentFailed,

        // Getters

        // Actions
        reset,
    };
});
